import { combineActions, handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUpserters } from 'app-components/flux/core';

import * as actions from './accountsBalancesActions';

const accountsBalancesReducer = handleActions(
  {
    [actions.getAccountsBalances]: (state) => state.merge({ isLoading: true }),
    [actions.getAccountsBalancesSuccess]: (state, action) => resourceUpserters.upsertResources(state, action.payload),
    [actions.getAccountsBalancesFailure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),

    [actions.batchAccountsBalances]: (state, action) =>
      resourceUpserters.upsertResources(state, { resources: action.payload }),
    [actions.batchAccountsBalancesSuccess]: (state, action) =>
      resourceUpserters.upsertResources(state, { resources: action.payload }),

    [combineActions(actions.batchAccountsBalancesFailure).toString()]: (state, { payload: error }) => {
      return resourceUpserters.resetResources(state, error);
    },
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const ACCOUNTS_BALANCES_REDUCER_KEY = 'accountsBalancesStore';
export default accountsBalancesReducer;
